import VueResource from  'vue-resource';
import turnplate from '../../components/vue/turnplate-new.vue';
import coupon from '../../components/vue/coupon.vue';
import getAward from '../../components/vue/getaward-new.vue';
import intro from '../../components/vue/intro.vue';
import './index.less';
import moment from 'moment';
import common from '../../common/js/common';
Vue.use(VueResource);
Vue.config.silent = false; //取消vue所有的日志和警告

common.shouldLogin();

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();


Vue.filter('time', function (value) {
    return moment(value).format("YYYY-MM-DD HH:mm");
});

const routes = [
    {path: '/', redirect: '/turnplate'},
    {
        path: '/turnplate',
        component: turnplate,
        name: 'turnplate'
    }, {
        path: '/coupon',
        component: coupon,
        name: 'coupon'
    }, {
        path: '/intro/:shopId',
        component: intro,
        name: 'intro'
    }
];

const router = new VueRouter({
    routes
});

const main = new Vue({
    router,
    components: {
        'vm-get-award': getAward
    },
    created: function () {
        if(this.$route.path.search('&') !== -1) {
            this.$router.push({path:'/turnplate'});
        }
    },
    methods: {},
    data: function () {
        return {}
    }
}).$mount('#main');


/** WEBPACK FOOTER **
 ** ./app/seller/index.js
 **/